module.exports = __webpack_public_path__ + "img/form-3.80ce168a.svg";